export class LeagueModel {
    id: number = 0;
    name: string = '';
    club_id: number = 0;
    start_date: string = '2024-04-01T23:49';
    end_date: string = '2024-04-10T23:49';
    league_type_id: number = 1;
    schedule_type_id: number = 1;
    number_of_teams: number = 0;
    number_of_teams_playoffs: number = 0;
    playoff_start_date: string = '2024-04-04T23:49';
    playoff_end_date: string = '2024-04-08T23:49';
    playoff_type_id: number = 0;
    registration_start_date: string = '2024-04-01T23:49';
    registration_end_date: string = '2024-04-05T23:49';
}

export class userLeague extends LeagueModel {
    is_join!: boolean;
}

export interface ILeague {
    id: number;
    name: string;
    clubId: number;
    minimumAge: number | null;
    rating: number;
    registrationStartDate: Date | null;
    registrationEndDate: Date | null;
    startDate: Date | null;
    endDate: Date | null;
    playoff: boolean;
    playoffStartDate: Date | null;
    playoffEndDate: Date | null;
    leagueType: string;
    teamSize: number;
    gender: string;
    menSinglesCount: number;
    womenSinglesCount: number;
    menDoublesCount: number;
    womenDoublesCount: number;
    mixedDoublesCount: number;
    maxNumberOfTeams: number;
    fees: number|null;
    canRegister: boolean;
    isRegistered: boolean;
    noOfRegisteredTeams: number;
    hasSchedule?: boolean;
    isParticipating?:boolean;
}

export interface ILeagueInfo {
    leagueId: number;
    leagueName: string;
    leagueType: string;
    leagueGender: string;
    email: string;
    rating: number;
    phoneNumber: string;
    registrationFees: number;
    homeCourt: {
        id: number;
        name: string;
        address1: string;
        address2: string;
        city: string;
        state: {
            id: number;
            code: string;
            name: string;
        };
        zip: string;
    };
    players: any[];
    teams: any[];
}